export default "__VITE_ASSET__HZm$zuqz__"